import React from 'react';
import { find, includes } from 'lodash';
import { unitsOptions } from './MeasurementOptions';
import { unitsMapping, returnedTypes, measurementType } from './MeasurementEnums';
import { observer } from 'mobx-react-lite';
import useStores from '../../hooks/useStores';
import classNames from 'classnames';
import styles from './index.module.scss';

function UnitWidget({
  value,
  type,
  returnedType,
  className,
}: {
  value: number;
  type: measurementType;
  returnedType: returnedTypes;
  className?: string;
}) {
  const { measurementsStore } = useStores();
  const item = find(
    unitsOptions,
    (x) => includes(unitsMapping[measurementsStore.unitsMapping], x.unit) && x.type === type,
  );

  return (
    <div>
      {returnedType === returnedTypes.value ? (
        item?.convert(value)?.toFixed(2)
      ) : returnedType === returnedTypes.unit ? (
        <div
          className={classNames(
            'text-neutrals-n-200-600 lowercase',
            styles.unitsContainer,
            className,
          )}
        >
          {item?.unit}
        </div>
      ) : (
        returnedType === returnedTypes.both && (
          <div>
            {item?.convert(value)?.toFixed(2)}
            <span className="text-neutrals-n-200-600 lowercase"> ({item?.unit})</span>
          </div>
        )
      )}
    </div>
  );
}
export default observer(UnitWidget);
